















import { Inject, Component, Vue, Ref } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import ListItemsList from './ListItemsList.vue';
import EditListItem from './listitem/EditListItem.vue';
import { Listitem } from '@/data/models/listitem.model';

@Component({
	components: {
		ListItemsList,
		EditListItem,
	},
})
export default class Liste extends Vue {
	@Ref('list') list!: ListItemsList;
	@Inject('CrudService') listItemCrudService!: CrudService<Listitem>;

	parentid!: number;

	constructor() {
		super();
	}

	addListItem() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditListItem,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Listitem) => {
					value.lid = this.parentid;
					this.listItemCrudService
						.createEntity(Listitem, 'selistitem', value)
						.then(() => {
							this.$buefy.notification.open({
								message: this.$t('success-save') as string,
								type: 'is-success',
							});
							this.list.loadListItems();
							modal.close();
						})
						.catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
				},
			},
		});
	}

	beforeMount() {
		this.parentid = parseInt(this.$route.params.id);
	}
}
